export enum TeamRoutesNamesEnum {
  team = 'team',
  teamProjects = 'team-projects',
  teamMembers = 'team-members'
}
